import { createReducer, createSelector, on } from '@ngrx/store';
import { PepActions } from '../actions';
import { FullData } from 'src/app/shared/interfaces/interfaces';

export interface PepDataState {
  pepData: FullData;
  pepStatus: boolean;
}

export const PepInitialState: PepDataState = {
  pepData: {
    pepDefault: false,
    showPep: false,
    isPepActivate: null,
    experiencia: 'customer-info-update',
    content: {
      pep: {
        cargo: '',
        institucion: '',
        fechaInicio: ''
      },
      padre: {},
      madre: {},
      conyuge: {},
      hijos: [{}],
      suegro: {},
      suegra: {},
      yernoONuera: [{}],
      AbueloPaterno: {},
      AbuelaPaterno: {},
      AbueloMaterno: {},
      AbuelaMaterno: {},
      Nietos: [{}],
      Hermanos: [{}],
      capitalMayor25: false,
      capitales: [{}]
    }
  },
  pepStatus: false
};

const featureSelector = (state: PepDataState) => state;

export const selectors = {
  executive: createSelector(featureSelector, (state) => state.pepData)
};

const _pepReducer = createReducer(
  PepInitialState,
  on(PepActions.savePepData, (state, { pepData, pepStatus }) => ({
      ...state,
      pepData,
      pepStatus
  }))
);

export function pepReducer(state, action) {
  return _pepReducer(state, action);
}
